import { toast,  } from 'react-toastify';


export const notifySuccess = async (message: string ) => {
    return  toast.success(message, {
      position: "top-right",
      bodyStyle: { color: "white", fontFamily: "serif" },
      closeButton: false,
      style: {
        background: "rgba(18, 183, 106, 1)",
        display:'flex',
        flexDirection:'row',
        borderRadius: 12,
      },
    });
    }
export const notifyError = async (message: string ) => {
    return  toast.error(message, {
      position: "top-right",
      bodyStyle: { color: "white", fontFamily: "serif" },
      closeButton: false,
      style: {
        background: "rgba(255,148,148)",
        display:'flex',
        flexDirection:'row',
        borderRadius: 12,
      },
    });
    }